import React, { Component } from "react";
import "./deviceSet.less";
import DeviceManagePage from "./deviceManagePage/deviceManagePage";
import DeviceDetailPage from "./deviceDetailPage/deviceDetailPage";
import DesignView from "../admin/designView/designView";
import { DEVICE_show_layout,DEVICE_show_ota } from "../../const/infoConst";
import { meshLog } from "../../utils/spUtils";
import PubSub from 'pubsub-js';

export default class DeviceSet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOtaPage: false, 
    };
  }
  componentDidMount() {

  }

  getDataFromManage = (msg) => {
    meshLog('getDataFromManage', msg);
    if(msg==DEVICE_show_layout){
      this.setState({
        showOtaPage: false,
      });
    }else if(msg==DEVICE_show_ota){
      this.setState({
        showOtaPage: true,
      });
    }
  }


  render() {
    return (
      <div className="device_container">
        {/* 左侧边栏 */}
        <div className="sidebar1"><DeviceManagePage onDataToParent={this.getDataFromManage} /></div>

        {/* 右侧平面图区域 */}
        <div className="content">
          <div className="bg-image" style={{ display: this.state.showOtaPage?"none":"flex"}}><DesignView /></div>
          <div className="bg-image" style={{ display: this.state.showOtaPage?"flex":"none"}}><DeviceDetailPage/></div>
        </div>
      </div>
    )
  }
}
